import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { applyPosthogConsent } from "@/instrument";
import { getCookieConsent, setCookieConsent, COOKIE_CONSENT_EVENT } from "@/utils";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent === null) {
      applyPosthogConsent(false);
      setIsVisible(true);
    } else {
      applyPosthogConsent(consent === "accepted");
    }

    const onConsentChanged = () => setIsVisible(false);
    window.addEventListener(COOKIE_CONSENT_EVENT, onConsentChanged);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onConsentChanged);
  }, []);

  const onChoice = (value) => {
    setCookieConsent(value);
    applyPosthogConsent(value === "accepted");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] sm:bottom-4 sm:right-4 sm:left-auto sm:max-w-sm">
      <div className="bg-white p-4 border-t border-gray-950/10 safe-bottom sm:rounded-2xl sm:border-t-0 sm:shadow-lg sm:ring-1 sm:ring-black/5">
        <p className="text-sm font-semibold text-gray-900">Cookies</p>
        <p className="mt-1 text-sm text-gray-600">
          Nous utilisons des traceurs de mesure d'audience, avec votre consentement, pour améliorer ce service.{" "}
          <Link to="/cookies" className="text-primary hover:underline">
            En savoir plus
          </Link>
        </p>
        <div className="mt-3 flex gap-2">
          <button
            onClick={() => onChoice("refused")}
            className="flex-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            Refuser
          </button>
          <button
            onClick={() => onChoice("accepted")}
            className="flex-1 px-3 py-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
